import env from 'env';

/**
 * This will get a recaptcha token if recaptcha thinks it's valid
 *
 * @returns {Promise} that has the token
 */

export const getRecaptchaToken = (action) => {
  const grecaptcha = window.grecaptcha || {};
  return new Promise((resolve, reject) => {
    if (grecaptcha?.ready) {
      grecaptcha.ready(() => {
        grecaptcha
          .execute(env.RECAPTCHA_SITE_KEY, { action })
          .then((token) => resolve(token))
          .catch((error) => reject(error));
      });
    } else {
      reject('grecaptcha not loaded');
    }
  });
};
